var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader--wrap",style:([{ backgroundColor: _vm.bgColor ? _vm.bgColor : 'inherit' }])},[_c('SquareLoader',{attrs:{"color":_vm.color}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }